<div class="img-container">
    <media-image [media]="album" default="album"></media-image>
    <playback-control-button (play)="play()" (pause)="pause()" [playing]="playing()"></playback-control-button>
</div>
<div class="footer">
    <a class="album-name primary-text" [routerLink]="urls.album(album)">{{album.name}}</a>
    <artists-links-list class="artist-name secondary-text" *ngIf="album.artist"  [artists]="[album.artist]"></artists-links-list>
</div>